export const infiniteScrollDistanceDefault = 2;
export const infiniteScrollThrottleDefault = 50;
export const infiniteScrollThrottle = 100;
